export const ROUTE_ENDPOINTS = {
  LANDING: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  HOME: "/home/*",
  GAME: "/game",
  GAME_FINISHED: "/game_finished",
  HOME_PLAY: "/home/play",
  HOME_DASHBOARD: "/home/dashboard",
  HOME_PLAYED_GAMES: "/home/played_games",
  HOME_PROFILE: "/home/profile",
  HOME_RESET_QUESTIONS: "/home/reset_questions",
  HOME_UNFINISHED_GAMES: "/home/unfinished_games",
  HOME_TRANSACTIONS: "/home/transactions",
  DASHBOARD: "/dashboard",
  PLAYED_GAMES: "/played_games",
  PROFILE: "/profile",
  PLAY: "/play",
  RESET_QUESTIONS: "/reset_questions",
  UNFINISHED_GAMES: "/unfinished_games",
  TRANSACTIONS: "/transactions",
  PAYMENT_STATUS: "/paymentStatus/*",
  QRCODE_ANSWERS: "/qrcode/answers",
  UNLOCK_CODE: "/unlockCode",
  RESET_PASSWORD: "/resetPassword",
  FORGOT_PASSWORD: "/forgotPassword",
};

export const ROUTE_NEW = "new";
